import React from 'react';
import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';
import ElementLink from '../ElementLink/ElementLink';
import styles from './Breadcrumb.module.scss';

export const BreadcrumbPropTypes = {
  breadcrumbs: PropTypes.arrayOf(PropTypes.object).isRequired
};

function Breadcrumb({ breadcrumbs }) {
  // if (!breadcrumbText) throw Error('Not found: breadcrumbText');
  const { t } = useTranslation();

  let currentPosition = 1;
  const baseBreadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': [
      {
        '@type': 'ListItem',
        'position': currentPosition,
        'item': {
          '@id': `${process.env.HOST}/`,
          'name': t('common:textBreadcrumbRoot')
        }
      }
    ]
  };

  return (
    <div className={styles.breadcrumb}>
      <div className={styles.breadcrumbWrap}>
        <nav aria-label="Breadcrumbs" data-testid="Breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <ElementLink
                href="/"
                as="/"
                isModal={false}
                className={styles.breadcrumbLink}
                trackingId={`breadcrumb_item_home`}
                download={false}
                linkText={t('common:textBreadcrumbRoot')}
                data-testid="Breadcrumb-linkOneText">
                {t('common:textBreadcrumbRoot')}
              </ElementLink>
            </li>
            {breadcrumbs && Array.isArray(breadcrumbs) && breadcrumbs.length > 0 && breadcrumbs?.[0]?.as?.includes('self-guided-learning') ?
              <li className="breadcrumb-item">
                <ElementLink
                  href="/self-guided-learning"
                  as="/self-guided-learning"
                  isModal={false}
                  className={styles.breadcrumbLink}
                  trackingId={`breadcrumb_item_self-guided-learning`}
                  download={false}
                  linkText={t('common:textBreadcrumbRoot')}
                  data-testid="Breadcrumb-linkOneText">
                  {t('Self-guided learning')}
                </ElementLink>
              </li> : null
            }
            {breadcrumbs && Array.isArray(breadcrumbs) && breadcrumbs.length > 0 && breadcrumbs?.[0]?.as?.includes('virtual-training') ?
              <li className="breadcrumb-item">
                <ElementLink
                  href="/virtual-training"
                  as="/virtual-training"
                  isModal={false}
                  className={styles.breadcrumbLink}
                  trackingId={`breadcrumb_item_virtual-training`}
                  download={false}
                  linkText={t('common:textBreadcrumbRoot')}
                  data-testid="Breadcrumb-linkOneText">
                  {t('Virtual training')}
                </ElementLink>
              </li> : null
            }

            {breadcrumbs && breadcrumbs.length
              ? breadcrumbs.map((breadcrumb, i) => {
                currentPosition += 1;
                const activeClass = breadcrumbs.length === i + 1 ? 'active' : '';

                baseBreadcrumbSchema.itemListElement.push({
                  '@type': 'ListItem',
                  'position': currentPosition,
                  'item': {
                    '@id': `${process.env.HOST}/${breadcrumb.as}`,
                    'name': breadcrumb.text
                  }
                });

                return (
                  <li
                    className={`breadcrumb-item ${activeClass}`}
                    aria-current="page"
                    key={`breadrumb-link-${breadcrumb.as}`}>
                    {!activeClass ? (
                      <ElementLink
                        href={breadcrumb.href}
                        as={breadcrumb.as}
                        trackingId={`breadcrumb_item_${breadcrumb.href}`}
                        isModal={false}
                        className={styles.breadcrumbLink}
                        download={false}
                        linkText={breadcrumb.text}
                        data-testid="Breadcrumb-linkOneText">
                        {breadcrumb.text}
                      </ElementLink>
                    ) : (
                      breadcrumb.text
                    )}
                  </li>
                );
              })
              : null}
          </ol>
        </nav>

        {/* eslint-disable-next-line react/no-danger */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(baseBreadcrumbSchema) }} />
      </div>
    </div>
  );
}

Breadcrumb.propTypes = BreadcrumbPropTypes;

export default Breadcrumb;
